import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { useDeleteOrderMutation } from "@src/__generated__/graphql";
import { ModalConfirm } from "@src/components/ui-kit";
import { DataTableActionButton } from "@src/components/ui-kit/DataTable/DataTableActionButton";
import { ModalOrder } from "@src/components/widgets/Modals/ModalOrder";
import { onError } from "@src/utils/apollo";
import { can, withCan } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import React, { type FunctionComponent, useContext } from "react";
import type { OrderModel } from "../../models";
import { DocumentsCtx } from "../../StoreDocuments";

export const PopoverRowActions: FunctionComponent<
  React.PropsWithChildren<{ order: OrderModel }>
> = withCan(
  { do: ["order_update", "order_delete"], fail: false },
  observer(function PopoverRowActions({ order }) {
    const pageStore = useContext(DocumentsCtx);

    const editModal = useDisclosure();
    const delModal = useDisclosure();

    const [del] = useDeleteOrderMutation({
      variables: { id: order.id },
      onCompleted() {
        pageStore.refetchOrders?.();
        delModal.onClose();
      },
      ...onError(),
    });

    return (
      <React.Fragment>
        <Menu>
          <MenuButton as={DataTableActionButton} />
          <MenuList>
            {can("order_update") && (
              <MenuItem onClick={editModal.onOpen}>
                <Trans>Edit</Trans>
              </MenuItem>
            )}
            {can("order_delete") && (
              <MenuItem {...delModal.getButtonProps()}>
                <Trans>Delete</Trans>
              </MenuItem>
            )}
          </MenuList>
        </Menu>
        <ModalConfirm
          {...delModal.getDisclosureProps()}
          {...delModal}
          onConfirm={del}
        />
        <ModalOrder
          order={order}
          {...editModal}
          onSubmit={pageStore.refetchOrders}
        />
      </React.Fragment>
    );
  }),
);
